import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

type Props = {
  open: boolean
  username: string
  action: "download" | "email"
  onClose: () => void
}

export function VpnPasswordUnavailableDialog({
  open,
  username,
  action,
  onClose,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Senha nao disponivel</DialogTitle>
          <DialogDescription>
            A senha de{" "}
            <span className="font-mono font-medium">{username}</span> nao esta
            disponivel nesta sessao. Para{" "}
            {action === "email"
              ? "enviar o acesso por e-mail com senha"
              : "visualizar a senha junto com o download"}
            , reemita/reative o acesso para gerar uma nova senha.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button type="button" onClick={onClose}>
            Fechar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
